import React from "react";
import {Route, Routes} from "react-router-dom";
import {Box} from "@mui/material";
import {AdminLeaderboardList} from "./AdminLeaderboardList";

export const AdminLeaderboardPage: React.FC = () => (
	<Box data-test-id="admin-leaderboard-router">
		<Routes>
			<Route index element={<AdminLeaderboardList />} />
		</Routes>
	</Box>
);
